import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { ElementsService } from '@app/store/effects/elements.service';
import {
    ErrorInterface,
    PolicyProductIdEnum,
    PurchasedProductInterface,
    RelationCodeEnum,
    RelationInterface
} from 'outshared-lib';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ChangeDriverElementInterface, mapChangeDriverElements } from './mappers/change-driver-elements.mapper';
import { ElementInterface } from "@app/core/interfaces";

const RELATION_CODE_ELEMENT_NAME = 'relatie_code';

@Component({
    selector: 'ins-insurance-regular-driver-form',
    templateUrl: './insurance-regular-driver-form.component.html',
    styleUrls: ['./insurance-regular-driver-form.component.scss'],
})
export class InsuranceRegularDriverFormComponent implements OnInit, OnDestroy {
    @Input() public purchasedProduct!: PurchasedProductInterface;
    @Input() public relation!: RelationInterface;

    public form: UntypedFormGroup;
    public elements: ChangeDriverElementInterface[];
    public productIdEnum: typeof PolicyProductIdEnum;
    public relationCodeEnum: typeof RelationCodeEnum;
    public errors: ErrorInterface[];

    private subscription: Subscription;

    constructor(
        private elementsService: ElementsService,
        private changeDetectorRef: ChangeDetectorRef,
    ) {
        this.elements = [];
        this.productIdEnum = PolicyProductIdEnum;
        this.relationCodeEnum = RelationCodeEnum;
        this.errors = [];
        this.subscription = new Subscription();
    }

    public get isDeviantDriver(): boolean {
        return Boolean([RelationCodeEnum.Partner, RelationCodeEnum.Child].includes(this.relationCode.value));
    }

    public get isVehicle(): boolean {
        return Boolean([
            PolicyProductIdEnum.Car,
            PolicyProductIdEnum.Moped,
            PolicyProductIdEnum.Motorcycle,
        ].includes(this.purchasedProduct?.productId));
    }

    public get relationCode(): AbstractControl {
        return this.form.get('relationCode');
    }

    public ngOnInit(): void {
        this.getElement();
        this.form = this.createForm(this.purchasedProduct?.productDetails?.regularDriver?.relationCode);
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    private createForm(relationCode?: RelationCodeEnum): FormGroup {
        return new UntypedFormGroup({
            relationCode: new FormControl(relationCode ?? '', [Validators.required]),
        });
    }

    private getElement(): void {
        const getElement = this.elementsService
            .getElement$(RELATION_CODE_ELEMENT_NAME)
            .pipe(
                // inhoud_id type is string but needs to be RelationCodeEnum
                map((elements: ElementInterface) => mapChangeDriverElements(elements)),
                map((elements: ChangeDriverElementInterface[]) => elements.filter(
                    (element: ChangeDriverElementInterface) => this.filterDeviantDriver(element.contentId))),
            )
            .subscribe({
                next: (elements: ChangeDriverElementInterface[]) => {
                    this.elements = elements;
                    this.validatePolicyHolder();
                    this.changeDetectorRef.detectChanges();
                },
            });

        this.subscription.add(getElement);
    }

    private validatePolicyHolder(): void {
        if (!this.purchasedProduct?.productDetails?.regularDriver) {
            return;
        }

        const policyHolder: ChangeDriverElementInterface = {
            contentId: RelationCodeEnum.Owner, // Owner === PolicyHolder
            contentDescription: 'Ikzelf',
        };

        this.elements.unshift(policyHolder);
    }

    private filterDeviantDriver(relationCode: RelationCodeEnum): boolean {
        return [RelationCodeEnum.Partner, RelationCodeEnum.Child].includes(relationCode);
    }
}
